import { z } from 'zod';
import { createEnumSchemaPreprocessor } from '../../../utils/create-enum-schema-preprocessor';

export const unitsOfMeasurementOptions = ['Imperial', 'Metric'] as const;

export const unitsOfMeasurementSchema = createEnumSchemaPreprocessor(
  z.enum(unitsOfMeasurementOptions),
  unitsOfMeasurementOptions
);

export type UnitsOfMeasurement = z.infer<typeof unitsOfMeasurementSchema>;
